
/* ============================== src/utils/taskTimeLog.js ============================== */
// src/utils/taskTimeLog.js
/**
 * Чистая логика учёта часов на фронте: блокировка записи для статуса
 * «Новая» (STATUS_NEW_LOG_MESSAGE + isLogBlockedByTaskStatus).
 *
 * Ранее здесь были commitTaskTimeLog / validateLogEntry /
 * validateOvertimeLimits / getHourlyOverrunDialog / getDayCheckDialog —
 * после перехода проверок на бэк (TaskService.addLog/updateLog → 409
 * HOURLY_PLAN_EXCEEDED / OVERTIME_LIMIT_EXCEEDED / OVERTIME_YEAR_EXCEEDED /
 * NON_WORKING_DAY / DAILY_NORM_EXCEEDED с details.needsConfirmation)
 * они не вызываются и удалены. Фронт опирается на 409-ответы бэка.
 */

export const STATUS_NEW_LOG_MESSAGE =
  "Нельзя вносить часы по задаче в статусе «Новая». " +
  "Сначала переведите задачу в статус «В работе».";

export function isLogBlockedByTaskStatus(task) {
  return !!(task.id && task.status === "new");
}
